import { lazy } from 'react';
import type { RouteItem } from '../route';

const Share = lazy(() => import('../pages/Share'));
const OpenApp = lazy(() => import('../pages/OpenApp'));
const Blank = lazy(() => import('../pages/Blank'));

const routes: RouteItem[] = [
  {
    path: '/',
    element: <Blank />,
  },
  {
    path: '/s/:shareId',
    element: <Share />,
	},
	{
    path: '/c',
    element: <OpenApp />,
  },
  {
    path: '*',
    element: <Blank />,
  },
];

export default routes;
